const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const GetBlockDayList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_BLOCKDAY_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_BLOCKDAY_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default GetBlockDayList;